import MissingAuthorizationPage from "../../pages/error/MissingAuthorizationPage";
import React from "react";
import Keycloak from "keycloak-js";

export enum ROLES {
    GLOW_ADMIN = 'GLOW_ADMIN',
    GLOW_TEST_DEVELOPER = 'GLOW_TEST_DEVELOPER',
    GLOW_TEST_DESIGNER = 'GLOW_TEST_DESIGNER',
    GLOW_TEST_MANAGER = 'GLOW_TEST_MANAGER',
    GLOW_TEST_VISITOR = 'GLOW_TEST_VISITOR'
}

export const isAdmin = (keycloak) => {
    return keycloak?.tokenParsed?.resource_access?.['glow-application']?.roles?.includes(ROLES.GLOW_ADMIN) ?? false
}

export const isTestDeveloper = (keycloak) => {
    return keycloak?.tokenParsed?.resource_access?.['glow-application']?.roles?.includes(ROLES.GLOW_TEST_DEVELOPER) ?? false
}

export const isTestDesigner = (keycloak) => {
    return keycloak?.tokenParsed?.resource_access?.['glow-application']?.roles?.includes(ROLES.GLOW_TEST_DESIGNER) ?? false
}

export const isTestManager = (keycloak) => {
    return keycloak?.tokenParsed?.resource_access?.['glow-application']?.roles?.includes(ROLES.GLOW_TEST_MANAGER) ?? false
}

export const isVisitor = (keycloak) => {
    return keycloak?.tokenParsed?.resource_access?.['glow-application']?.roles?.includes(ROLES.GLOW_TEST_VISITOR) ?? false
}

export const hasRole = (roles: ROLES[], keycloak): boolean => {
    return roles.some(role =>
        keycloak?.tokenParsed?.resource_access?.['glow-application']?.roles?.includes(role) ?? false
    );
}